<template>
  <v-list-item height="100%">
    <v-container fluid class="pa-0">
      <v-row>
        <v-col align="center">
          <span v-html="factoringModel.getPendingText()" />
        </v-col>
      </v-row>

      <v-row justify="center">
        <!-- SIMPLE MODEL -->
        <v-col v-if="factoringModel.isSimpleModel()" class="invoice-col" cols="4">
          <SmallInvoice v-if="factoringModel.iAmThePayer()" :user-prop="user" :invoice="factoring.invoice_payer" full />
          <SmallInvoice v-if="factoringModel.iAmTheReceiver()" :user-prop="user" :invoice="factoring.invoice_receiver" full />
        </v-col>

        <!-- FACTOR MODEL -->
        <v-col v-if="factoringModel.isFactorModel()" class="invoice-col" cols="4">
          <SmallInvoice v-if="factoringModel.iAmTheReceiver() || factoringModel.iAmThePayer()" :user-prop="user" :invoice="factoring.invoice_compensated" full />
        </v-col>


        <v-col v-if="factoringModel.isFactorModel() && factoringModel.iAmThePayer()" class="invoice-col">
          <SmallInvoice :invoice="factoring.invoice_payer" :user-prop="user" full />
          <SmallInvoice :invoice="factoring.invoice_payer" :user-prop="user" full />
        </v-col>

        <!-- TRIANGLE MODEL -->
        <v-col v-if="factoringModel.isTriangleModel()" class="invoice-col" cols="4">
          <SmallInvoice v-if="factoringModel.iAmThePayer()" :user-prop="user" :invoice="factoring.invoice_payer" full />
          <SmallInvoice v-if="factoringModel.iAmTheReceiver()" :user-prop="user" :invoice="factoring.invoice_receiver" full />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card flat>
            <v-card-text align="center">
              <span v-html="factoringModel.calculateProposalLine2(this.$user)" />
              <br v-if="factoringModel.calculateProposalLine1(this.$user).length > 0 && factoringModel.calculateProposalLine2(this.$user).length > 0">
              <span v-html="factoringModel.calculateProposalLine1(this.$user)" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-col v-if="showActionButtons()">
        <v-row justify="center">
          <v-btn x-large color="primary" @click="onAccept()">
            {{ $t('ACCEPT') }}
          </v-btn>
        </v-row>
        <v-row justify="center" style="margin-top: 20px; margin-bottom: 10px">
          <v-btn x-large @click="onReject()">
            {{ $t('DENY') }}
          </v-btn>
        </v-row>
      </v-col>
    </v-container>
  </v-list-item>
</template>

<script>
import SmallInvoice from "../invoice/SmallInvoice";
import ApiRepository from "../../repositories/ApiRepository";
import Constants from "../../../constants";
import {Factoring} from "../../models/factoring";

export default {
    name: 'PendingFactoringItem',
    components: {SmallInvoice},
    props: {
        factoring: {
            type: Object,
            default: null
        },
        userProp: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        factoringModel: null,
        user: null
    }),
    created () {
        if (this.userProp) this.user = this.userProp;
        else this.user = this.$user;
        this.factoringModel = new Factoring(this.factoring, this.user, this.$parameters);
    },
    methods: {

        onAccept () {
            let title = this.$t('Confirmation'), message = this.$t('PendingFactoringItem.Do you want to accept this bypay?'), button = false;
            if (!this.$user) {
                title = this.$t('PendingFactoringItem.USER NOT LOGGED!');
                message = this.$t('PendingFactoringItem.You are not logged into the platform, please login or register to perform some action');
                button = true;
            }
            this.$root.$emit('show-confirmation-modal', {
                title: title,
                message: message,
                oneButton: button,
                yes: () => {
                    if (this.$user) {
                        this.accept();
                    } else {
                        localStorage.setItem('email-user-compensation',  this.userProp.email);
                        this.$router.push({name: 'Login'});
                    }

                },
            });
        },

        accept () {
            this.$emit('startLoading');
            let nextStatus;
            if (this.factoringModel.iAmThePayer() && this.factoring.status === Constants.FACTORING.STATUS_CREATED && this.factoringModel.isSimpleModel()) {
                nextStatus = Constants.FACTORING.STATUS_PAYED;
            } else if (( (this.factoringModel.iAmThePayer()) || (this.factoringModel.iAmTheReceiver()) ) && this.factoring.status === Constants.FACTORING.STATUS_CREATED)
                nextStatus = Constants.FACTORING.STATUS_ACCEPTED;
            else if ( (this.factoringModel.iAmThePayer()) || (this.factoringModel.iAmTheReceiver())  && this.factoring.status !== Constants.FACTORING.STATUS_CREATED)
                nextStatus = Constants.FACTORING.STATUS_PAYED;

            if (this.factoringModel.isFactorModel()) {
                if (this.factoringModel.iAmThePayer())
                    nextStatus = Constants.FACTORING.STATUS_PAYED;
                else
                    nextStatus = Constants.FACTORING.STATUS_ACCEPTED;
            }
            ApiRepository.updateFactoring(this.factoring._id, nextStatus)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('PendingFactoringItem.Petition accepted successfully!')});
                    this.$router.push({name: 'home', replace: true});
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Error accepting petition'), color: 'error'});
                    console.error(err);
                });
        },

        onReject () {
            let title = this.$t('Confirmation'), message = this.$t('PendingFactoringItem.Do you want to accept this bypay?'), button = false;
            if (!this.$user) {
                title = this.$t('PendingFactoringItem.USER NOT LOGGED!');
                message = this.$t('PendingFactoringItem.You are not logged into the platform, please login or register to perform some action');
                button = true;
            }
            this.$root.$emit('show-confirmation-modal', {
                title: title,
                message: message,
                oneButton: button,
                yes: () => {
                    if (this.$user) this.reject();
                    else this.$router.push({name: 'Login'});

                },
            });
        },

        reject () {
            this.$emit('startLoading');
            let nextStatus = this.factoringModel.iAmTheReceiver() ?  Constants.FACTORING.STATUS_REJECTED : Constants.FACTORING.STATUS_UNPAYED;
            nextStatus = this.factoringModel.iAmThePayer() ?  Constants.FACTORING.STATUS_REJECTED : Constants.FACTORING.STATUS_UNPAYED;

            if (this.factoringModel.isFactorModel()) {
                if (this.factoringModel.iAmThePayer())
                    nextStatus = Constants.FACTORING.STATUS_UNPAYED;
                else
                    nextStatus = Constants.FACTORING.STATUS_REJECTED;
            }
            ApiRepository.updateFactoring(this.factoring._id, nextStatus)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Petition rejected')});
                    this.$router.push({name: 'home', replace: true});
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Error rejecting petition'), color: 'error'});
                    console.error(err);
                });
            /*this.$emit('startLoading');
            let nextStatus = this.factoringModel.iAmThePayer() ?  Constants.FACTORING.STATUS_REJECTED : Constants.FACTORING.STATUS_UNPAYED;

            if (this.factoringModel.isFactorModel()) {
                if (this.factoringModel.iAmThePayer())
                    nextStatus = Constants.FACTORING.STATUS_UNPAYED;
                else
                    nextStatus = Constants.FACTORING.STATUS_REJECTED;
            }
            ApiRepository.updateFactoring(this.factoring._id, nextStatus)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Petition rejected')});
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error rejecting petition'), color: 'error'});
                    console.error(err);
                });*/
        },
        showActionButtons () {
            return !(this.factoring.acceptedBy === 3 || (this.factoringModel.iAmTheReceiver() && this.factoring.acceptedBy === 1) || (this.factoringModel.iAmThePayer() && this.factoring.acceptedBy === 0) );
        }
    }
};
</script>

<style scoped>
  .v-card__text {
    padding: 10px;
  }
  .invoice-col {
    min-width: 300px;
  }
</style>

